import { render, staticRenderFns } from "./treatment-selection.vue?vue&type=template&id=03ebfc52&"
import script from "./treatment-selection.vue?vue&type=script&lang=ts&"
export * from "./treatment-selection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports